import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import { API } from 'api';

const initialState = {};

export const driverSlice = createSlice({
	name: 'driverState',
	initialState,
	reducers: {},
});

export const getDriverList =
	({ search_type = '', limit = 10, offset = 10, currentPage, ...rest }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				offset,
				limit,
				filter_list: {},
				filter_by: {
					...rest,
				},
			},
		};
		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
			cities: response?.filter_list?.cities,
			vendors: response?.filter_list?.vendors,
		}));
	};

export const getDownloadReportList =
	({ getFileName }) =>
	async () => {
		const apiData = {
			report_type: 'download_report',
			file_type: 'file',
			data: {
				filename: getFileName,
				url_type: 'download',
			},
		};
		const CREDENTIALS = {
			url: '/generate-report',
			data: apiData,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			window.open(res?.data?.download_url);
		});
	};

export const getDriverByID =
	({ search_type = '', ...rest }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				// offset,
				// limit,
				...rest,
			},
		};
		console.log(CREDENTIALS);
		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export const addDriver =
	({ data, setErrors }) =>
	async () => {
		console.log('data', data);
		console.log('setErrors', setErrors);
		const CREDENTIALS = {
			url: '/create',
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then(() => {
			toaster.success('Client added successfully');
			return true;
		});
	};

export default driverSlice.reducer;
